module.exports = __webpack_public_path__ + "img/lightning.dc5ffb2c.svg";